// German date and number texts.
import { addDays, dayToDate, type DayKey } from '../../shared/days';
import type { StreakUnit } from '../../shared/schedule';

const fmt = (options: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat('de-DE', options);
const longDay = fmt({ weekday: 'long', day: 'numeric', month: 'long' });
const shortDay = fmt({ weekday: 'short', day: 'numeric', month: 'short' });
const monthYear = fmt({ month: 'long', year: 'numeric' });
const fullDate = fmt({ weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

/** "Dienstag, 21. Oktober" */
export const formatLongDay = (day: DayKey) => longDay.format(dayToDate(day));
/** "Di., 21. Okt." */
export const formatShortDay = (day: DayKey) => shortDay.format(dayToDate(day));
/** "Oktober 2026" */
export const formatMonth = (day: DayKey) => monthYear.format(dayToDate(day));
/** "Dienstag, 21. Oktober 2026" */
export const formatFullDate = (day: DayKey) => fullDate.format(dayToDate(day));

/** "Heute", "Gestern", "Vorgestern" or the weekday with date. */
export function relativeDay(day: DayKey, today: DayKey): string {
  if (day === today) return 'Heute';
  if (day === addDays(today, -1)) return 'Gestern';
  if (day === addDays(today, -2)) return 'Vorgestern';
  return formatShortDay(day);
}

export function streakText(count: number, unit: StreakUnit): string {
  if (unit === 'weeks') return count === 1 ? '1 Woche' : `${count} Wochen`;
  return count === 1 ? '1 Tag' : `${count} Tage`;
}

export function percent(ratio: number | null): string {
  return ratio === null ? '–' : `${Math.round(ratio * 100)} %`;
}

export function greeting(now = new Date()): string {
  const hour = now.getHours();
  if (hour < 5) return 'Gute Nacht';
  if (hour < 11) return 'Guten Morgen';
  if (hour < 17) return 'Hallo';
  if (hour < 22) return 'Guten Abend';
  return 'Gute Nacht';
}
